import { getAppConstants } from '#/config/appConstants';

import type { UploadHookParams, UploadHookResult } from './types';
import { useFilestackUpload } from './useFilestackUpload';
import { useMockUpload } from './useMockUpload';

export function useUpload(params: UploadHookParams): UploadHookResult {
  return getAppConstants().filestackMockEnabled
    ? // oxlint-disable-next-line react-hooks/rules-of-hooks
      useMockUpload(params)
    : // oxlint-disable-next-line react-hooks/rules-of-hooks
      useFilestackUpload(params);
}
